import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getDeepViewValuesEntry } from "../../deepViewFieldMap";
import { renderDeepViewText } from "../../renderDeepViewText";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

/** Same as ManualAdjustment, in neutral grey rather than amber */
const ManualAdjustmentNeutral = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const stage5Text = getDeepViewValuesEntry(
    deepViewData,
    columnKey,
  )?.stage5_prefilled;

  if (!stage5Text) return null;

  return (
    <>
      <Box
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
          backgroundColor: "#FAFAFA",
          p: 1,
          mt: 1,
        }}
      >
        <Typography
          sx={{
            color: "#00000099",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          {renderDeepViewText(stage5Text)}
        </Typography>
      </Box>
    </>
  );
};

export default ManualAdjustmentNeutral;
